"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PowerButton2Alternate: ['power-button-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM12,3a9,9,0,1,1-9,9A9.01,9.01,0,0,1,12,3Z', 'M10.806,6.249h2.387a.977.977,0,0,1,.977.977v9.545a.978.978,0,0,1-.978.978H10.806a.978.978,0,0,1-.978-.978V7.227A.978.978,0,0,1,10.806,6.249Z']],
  PowerButton1: ['power-button-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM10.5,7a1.5,1.5,0,1,1,3,0v9.5a1.5,1.5,0,0,1-3,0Z']],
  PowerButton2: ['power-button-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm1.751,17.5a.5.5,0,0,1-.5.5h-2.5a.5.5,0,0,1-.5-.5V7.5a.5.5,0,0,1,.5-.5h2.5a.5.5,0,0,1,.5.5Z']],
  PowerButton1Alternate: ['power-button-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,21a9,9,0,1,1,9-9A9.01,9.01,0,0,1,12,21Z', 'M12,5.477a1.75,1.75,0,0,0-1.75,1.75V16.3a1.75,1.75,0,0,0,3.5,0V7.227A1.749,1.749,0,0,0,12,5.477Z']],
  EjectButton: ['eject-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm5,16a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1ZM12.742,7.075l3.379,3.755a1,1,0,0,1-.744,1.669H8.623a1,1,0,0,1-.744-1.669l3.377-3.753A1.034,1.034,0,0,1,12.742,7.075Z']],
  PowerButton: ['power-button', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.5,10.915a1.5,1.5,0,0,0,3,0V1.5a1.5,1.5,0,1,0-3,0Z', 'M1.2,11.533a10.917,10.917,0,0,0,18.52,9.272A10.825,10.825,0,0,0,22.8,11.527,11.021,11.021,0,0,0,17.067,3.4,1.5,1.5,0,1,0,15.63,6.03a8.048,8.048,0,0,1,4.2,5.925A7.914,7.914,0,0,1,6.4,18.684a7.854,7.854,0,0,1-2.237-6.726A8.042,8.042,0,0,1,8.36,6.036,1.5,1.5,0,1,0,6.919,3.405,11.015,11.015,0,0,0,1.2,11.533Z']]
};
exports["default"] = _default;